var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import { loadScript } from './loadScript';
var lastEditorId = 0;
var UnlayerEditor = /** @class */ (function (_super) {
    __extends(UnlayerEditor, _super);
    function UnlayerEditor(props) {
        var _this = _super.call(this, props) || this;
        _this.loadEditor = function () {
            if (_this.editor)
                return; // Prevent duplicate creation
            var options = _this.props.options || {};
            if (_this.props.projectId) {
                options.projectId = _this.props.projectId;
            }
            if (_this.props.tools) {
                options.tools = _this.props.tools;
            }
            if (_this.props.appearance) {
                options.appearance = _this.props.appearance;
            }
            if (_this.props.locale) {
                options.locale = _this.props.locale;
            }
            _this.editor = window.unlayer.createEditor(__assign({ id: _this.editorId, displayMode: 'email', source: {
                    name: 'react-email-editor',
                    version: '1.6.1',
                } }, options));
            // All properties starting with on[Name] are registered as event listeners.
            for (var _i = 0, _a = Object.entries(_this.props); _i < _a.length; _i++) {
                var _b = _a[_i], key = _b[0], value = _b[1];
                if (/^on/.test(key) && key !== 'onLoad' && key !== 'onReady') {
                    _this.addEventListener(key, value);
                }
            }
            var _c = _this.props, onLoad = _c.onLoad, onReady = _c.onReady;
            // @deprecated
            onLoad && onLoad();
            console.log("Created editor " + _this.editorId);
            if (onReady)
                _this.editor.addEventListener('editor:ready', function () { return onReady(_this.editor); });
        };
        _this.registerCallback = function (type, callback) {
            _this.editor.registerCallback(type, callback);
        };
        _this.addEventListener = function (type, callback) {
            _this.editor.addEventListener(type, callback);
        };
        _this.loadDesign = function (design) {
            _this.editor.loadDesign(design);
        };
        _this.saveDesign = function (callback) {
            _this.editor.saveDesign(callback);
        };
        _this.exportHtml = function (callback) {
            _this.editor.exportHtml(callback);
        };
        _this.setMergeTags = function (mergeTags) {
            _this.editor.setMergeTags(mergeTags);
        };
        _this.editorId = props.editorId || "editor-".concat(++lastEditorId);
        return _this;
    }
    UnlayerEditor.prototype.componentDidMount = function () {
        loadScript(this.loadEditor, this.props.scriptUrl);
    };
    UnlayerEditor.prototype.componentWillUnmount = function () {
        if (this.editor && this.editor.destroy) {
            this.editor.destroy();
        }
        this.editor = null;
    };
    UnlayerEditor.prototype.render = function () {
        var _a = this.props, _b = _a.minHeight, minHeight = _b === void 0 ? '100%' : _b, _c = _a.style, style = _c === void 0 ? {} : _c;
        return (_jsx("div", __assign({ style: {
                flex: 1,
                display: 'flex',
                minHeight: minHeight,
            } }, { children: _jsx("div", { id: this.editorId, style: __assign(__assign({}, style), { flex: 1 }) }) })));
    };
    return UnlayerEditor;
}(Component));
export default UnlayerEditor;
